import { MenuOption } from '@/components/componentLibrary/ButtonMenu'

export const IPS_APPS: MenuOption[] = [
  { text: 'IPS Data Management System', href: 'https://www.ipsmetersystems.com/' },
  { text: 'IPS Parking Enforcement Management', href: 'https://www.ipsenforcement.com/' },
  { text: 'IPS Permit Management', href: 'https://www.ipspermits.com/' },
]
